const videoControls = require("../video-controls");
$(document).on( 'mouseenter mouseleave', '.step__answer--with_background_hover, .step__answer--toggle_description_on_hover', (e) => {
    updateBackground(e.currentTarget, e.type === 'mouseenter');
});

const updateBackground = (answer, isEnter) => {
    const answerId = $(answer).data('answer-id');
    const step = $(answer).closest('.step');

    // Get the answer background
    const backgrounds = $(step).find( `.step__answer_backgrounds--image[data-answer-id="${answerId}"], .step__answer_backgrounds--video[data-answer-id="${answerId}"]` );
    if (backgrounds.length === 0) {
        return;
    }

    // Add active class
    $(answer).toggleClass('opened', isEnter);
    $(backgrounds).toggleClass('active', isEnter);
    $(answer).closest('.swiper-wrapper').toggleClass('hovered', isEnter);

    $(backgrounds).filter('video').each((i, backgroundVideo) => {
        backgroundVideo.currentTime = 0;
        $(backgroundVideo).trigger(videoControls.isVideoPaused || !isEnter ? 'pause' : 'play');
    });

    // Show step background
    $(step).find('.step__background').toggleClass('step__background--hidden', isEnter);
    $(step).find('.step__answer_backgrounds').toggleClass('step__answer_backgrounds--show', isEnter);
};
